import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { FlowOutputStepRuns } from '~src/flow/resources/FlowOutputStepRuns';
import { FlowOutputStepRunContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';

import { getGenericDefaultFilters } from '../../contentDefinitions/getDefaultFilters';

export const FlowOutputStepRunDefinition: ExplorableItemDefinition = {
  itemType: 'flowOutputStepRun',
  pluralName: Messages.flowRuns,
  singularName: Messages.flowRun,
  emptyStateMessage: Messages.flowRunsEmptyMessage,
  contentFilterKeys: FlowOutputStepRunContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: null,
  listViewIconUrl: '', // we don't display an icon for flow output step runs
  filterClause: ServerFilterClauses.ContentType(['flowOutputStepRun']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return FlowOutputStepRuns.all().withExtraParams(FlowOutputStepRunContentType.extraQueryParams);
  },
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for flowOutputStepRun');
  },
  supportedDisplayModes: ['list']
};
